const getBuilderStateContentVariantData = ({ builderStateContent }) => {
  const testVariationId = builderStateContent?.testVariationId;
  return (
    builderStateContent?.variations?.[testVariationId]?.data ||
    builderStateContent?.data
  );
};

export default getBuilderStateContentVariantData;
